import { SLIDE_ADAPTER } from '@src/framework/workbench/editor-adpater/slide-adapter';
import { PresetChartType } from '@src/slide/domain/ui-model/element-modeles/chart-models/chart-presets/const';
import { IChartTypeShower, STChartType } from '@tencent/chart-drawer-components/lib/interface';
import { Feature } from '@tencent/workbench';
import ChartBaseDrawerFeature from '@src/framework/workbench/drawer/ui/chart/chart-base-drawer-feature';
import { mappingSlideChartTypeToSTChartType } from '../../utils';
import { CHART_TYPE_CONFIG_FOR_SELECTOR } from './config';
import type { ChartConfigForSelector } from '@tencent/chart-drawer-components/lib/interface';
import _isNil from 'lodash/isNil';
import './index-global.less';

@Feature({
    name: 'ChartTypeSelectShower',
    adapters: [SLIDE_ADAPTER],
    provide: IChartTypeShower,
})
export class ChartTypeSelectShower extends ChartBaseDrawerFeature implements IChartTypeShower {
    public getChartTypeConfigForSelector(): ChartConfigForSelector[] {
        return CHART_TYPE_CONFIG_FOR_SELECTOR;
    }

    /**
     * 获取图表类型
     */
    public getChartType = (): STChartType => {
        const model = this.getSelectModel();
        if (!model?.plotArea) return STChartType.ClusteredColumn;
        const { charts } = model.plotArea;
        if (charts.length > 1) {
            const types = charts.map(chart => chart.getPresetChartType());
            const uniqTypes = [...new Set(types)];
            if (uniqTypes.length > 1) {
                // 成交量-盘高-盘低-收盘图 有多个chart, 返回股价图
                if (uniqTypes.includes(PresetChartType.STOCK)) {
                    return mappingSlideChartTypeToSTChartType(PresetChartType.STOCK);
                }
                return mappingSlideChartTypeToSTChartType(PresetChartType.COMBO);
            }
            return mappingSlideChartTypeToSTChartType(uniqTypes[0]);
        }
        return mappingSlideChartTypeToSTChartType(charts[0].getPresetChartType());
    };
}
